export default __webpack_public_path__ + "static/nano_horz_color-4x-822db5af8c048a94c887bd6e164c5e72.png";